import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { ASSETS } from "@/lib/api";

export default function TicketCancel() {
  return (
    <div className="min-h-screen bg-[var(--trio-bg)] flex flex-col items-center justify-center px-6 py-16">
      <div className="w-full max-w-md text-center" data-testid="ticket-cancel">
        <img src={ASSETS.logo} alt="Trio" className="h-14 w-auto mx-auto mb-6" />
        <XCircle className="w-16 h-16 mx-auto text-[var(--trio-muted)] mb-4" />
        <h1 className="font-display uppercase text-4xl tracking-tight mb-3">Checkout Cancelled</h1>
        <p className="text-sm text-[var(--trio-muted)] mb-6">
          No worries — nothing was charged. Come back when you're ready.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/events" className="inline-flex items-center justify-center gap-2 bg-[var(--trio-primary)] hover:bg-[var(--trio-primary-hover)] text-white px-6 py-3 text-sm tracking-widest uppercase font-bold">
            Back to Events
          </Link>
          <Link to="/" className="inline-flex items-center justify-center gap-2 border border-[var(--trio-text)] px-6 py-3 text-sm tracking-widest uppercase font-bold">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
